import React from "react";
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getApi } from "../../api/endpoints";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { selectQueryParams, setQueryParams, updateQueryParams } from "../../ui/customerListingReducer";

const RejectModal = (props) => {
  const {showRejectModal, setShowRejectModal, transactionDetails} = props;
  const [rejectTallyTransactionApi] = getApi('rejectTallyTransaction');
  const queryParams = useSelector(selectQueryParams);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    setShowRejectModal(false);
  }

  const onRejectTransactionClick = async () => {
    try{
      const response = await rejectTallyTransactionApi({id: `${transactionDetails.id}`}).unwrap();
      setShowRejectModal(false);
      toast.success(response.data.message || 'Transaction Rejected !');
      dispatch(updateQueryParams(setQueryParams(queryParams)));
    } catch(error) {
      setShowRejectModal(true);
      toast.error(error.data?.message || 'Something went wrong !');
    }
  }

  return <Modal
    show={showRejectModal}
    onHide={handleModalClose}
    backdrop="static"
    keyboard={false}
    centered
  >
    <Modal.Header
      style={{ backgroundImage: 'linear-gradient(103deg, #49c12b 0, #197800 99%)' }}
      className="text-white"
      closeButton
    >
      <Modal.Title>Reject Tally Transaction</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className='text-center m-2 text-warning'>
        <FontAwesomeIcon icon={faCircleExclamation} style={{ fontSize: '80px'}}/>
      </div>
      <p className='h4 text-center my-3 opacity-75'>
        Are you sure?
      </p>
      <p className='h6 text-center my-3 opacity-75 fw-normal'>
        You want to reject tally transaction <span className="fw-bold"> {transactionDetails?.tally_transaction_number} </span>
        for the <span className="fw-bold"> {transactionDetails?.transactn} </span>
        of amount <span className="fw-bold"> {transactionDetails?.amount} </span> ?
      </p>
    </Modal.Body>
    <Modal.Footer>
      <button 
        type="button"
        className="btn btn-sm rounded-5 btn-outline-secondary"
        style={{ width: "80px", fontSize: '16px' }}
        onClick={handleModalClose}
      >
        Cancel
      </button>
      <button
        type='submit'
        className='btn btn-sm remove-button'
        style={{ width: "80px", fontSize: '16px' }}
        onClick={(e) => {e.preventDefault(); onRejectTransactionClick()}}
      >
        Reject
      </button>
    </Modal.Footer>
  </Modal>
}

export default RejectModal;
